export class CommonConstants {
    public static DEFAULT_EMPTY_STRING = '';
    public static DEFAULT_NULL_STRING = 'null';
    public static DEFAULT_EMPTY_QUOTES_STRING = "''";
    public static ONLY_ALPHABETS_PATTERN_STRING: any = /^([a-zA-Z])$/;
    public static URL_SEPARATOR = '/';
    public static PIPE_SEPARATOR = '|';
    public static QUERY_PARAMETER_LITERAL = '?';
    public static EQUALS = '=';
    public static AMPERSAND = '&';
    public static PERCENTAGE_LITERAL = '%';
    public static EMAIL_PATTERN_STRING = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    public static CONTINUE = 'CONTINUE';
    public static RESUME = 'RESUME';
    public static TIMElIMIT = 9;
    public static TIMEMILISECONDS = 1000;
    public static OFFERAVAIL = 'avail';
    public static NEW_SOL_OFFER_PL = 'newPL';
    public static SERVERDATE = '3:45 PM 11/9/2016';
    public static DataLayerEvent = 'Next_click_commonoffer';
    // Cookie Keys

    public static APIURLBankSelection = {
        getBankList: `{DOMAIN01}/v2/smartsearch/banks?source=AASTANDALONE`,
        getPirimidBankList:`{DOMAIN01}/v1/webbff/banks?channel=PIRIMID`,
        initiateAA:`{DOMAIN01}/v1/webBFF/initiateAA`
      }
    
    public static CookieKeys = {
        AuthId: 'authId',
        NTID: 'NTID',
        AuthType: 'authType',
        State: 'state',
        Code: 'code',
        AuthToken: 'authToken',
        ProcessInstanceDetails: 'processInstanceDetails',
        LoanApplicationId: 'loanApplicationId',
        LoanApplicationKey: 'loanApplicationKey',
        Error: 'error',
        UserName: 'uDetails',
        DeviceDetails: 'DeviceDetails',
        ClientId: 'SC_ID',
        SecretKey: 'SS_ID',
        UserAuthenticationToken: 'UserAuthenticationToken',
        GeoLocationDetails: 'GeoLocationDetails',
        JWTokenCO: 'CT_1',
        GuardTokenCO: 'CT_2',
        GuardKeyCO: 'CT_4',
        JWToken: 'SS_1',
        GuardToken: 'SS_2',
        GuardKey: 'SS_4',
        EmployeeResume: 'SS_R_TYP',
        EmployeeResume_Value: 'emp',
        MobileRegistrationId: 'mobileregistrationid',
        MobileDeviceUUID: 'mobileDeviceuuid',
        MobileState: 'mobileState',
        //added for bflOcr
        AuthtokenUI: 'authtoken',
        incomeImpKey:'bflOcrIncomeImpKey',
        incomeImpBankKey:'incomeImpBankKey',
        redirectionUrlForJourney: 'redirectionUrl',
        ProcessId:'processId',
        
        bankName: 'bankName',
        retrycount :'retrycount'
    };
    public static CommonGatewayDateRanges = {
        SOL: {
            MinAge: 21,
            MaxAge: 58
        },
        SPPL: {
            MinAge: 21,
            MaxAge: 58
        },
        DHB: {
            MinAge: 23,
            MaxAge: 60
        },
        DHL: {
            MinAge: 23,
            MaxAge: 60
        },
        DLAP: {
            MinAge: 25,
            MaxAge: 58
        },
        DLAPB: {
            MinAge: 25,
            MaxAge: 58
        },
        DBOL: {
            MinAge: 26,
            MaxAge: 66
        },
        DDOL: {
            MinAge: 25,
            MaxAge: 72
        },
        DCAL: {
            MinAge: 25,
            MaxAge: 69
        },
    };
    public static LOAN_PRODUCT_CODES = {
        NEW_PL: 'SOL',
        SPPL: 'SPPL'
    };
    public static FLOW_TYPE = {
        oldFlow: 'oldFlow',
        newFlow: 'newFlow',
        secured: 'sl'
    };
    public static LOAN_PRODUCT_CATEGORY_CODES = {
        Unsecured_Loan: 'UL',
        Secured_Loan: 'SL',
        Travel_Insurance: 'ins',
        Health_Insurance: 'ins',
        Cyber_Insurance: 'ins'
    };
    public static encyKey = {
        keyToEncrypt: 'B1729a411698j58260a613355j556900'
    };
    public static QueryParamsKeys = {
        EmailToConfirmType: 'type',
        EmailTokenToConfirm: 'id',
        PaymentStatus_QueryParams: 'queryParams',
        appUtmRefCode: 'appUtmRefCode',
        appUtmSource: 'utm_source',
        appUtmMedium: 'utm_medium',
        appUtmCampaign: 'utm_campaign',
        appUtmTerm: 'utm_term',
        appUtmContent: 'utm_content',
        UTMData: 'UTMData',
        BFLBranch: 'BFLBranch',
        GCLID: 'gclid',
        Productcode: 'prdcode',
        Product: 'product',
        ApplicantId: 'apcantid',
        ApplicationId: 'aptionid',
        ApplicationApplicantId: 'apcaptid',
        flowType: 'flowType',
        professionType: 'professionType',
        occupationType: 'occupationType',
        prodCode: 'prodCode',
        mob: 'mob',
        dob: 'dob',
        applicationKey: 'applicationKey',
        applicantKey: 'applicantKey',
        applicationApplicantKey: 'applicationApplicantKey',
        offerExists: 'offerExists',
        loanApplicationKey: 'loanApplicationKey',
        offerId: 'offerId',
        IsMobile: 'isMobile',
        mRegistrationId: 'registrationId',
        mDeviceUUID: 'uuid',
        consentToken: 'consentToken',
        consentref:'consentref',
        applicationid:'applicationid',
        src: 'src',
        src_30: 'src_30',
        src_60: 'src_60',
        src_90: 'src_90',
        uci: 'uci',
        pid: 'pid',
        emailUTMParameter: 'emailUTMParameter',
        emailUTMValue: 'emailUTMValue',
        PlatformType: 'platformType',
        OtpRequired: 'otpRequired',
        EsignAppId:'applicationKey',
        consentChannel:'channel',
        consentType: 'consentType',
        actionRequired: 'action',
        authCode:'authCode',
        userRoleKey: 'userRoleKey',
        token:'token',
        source:'ep',
        productCode :'productCode',
        sessionId:'sessionId',
        productid:'productid',
        partnerType:'partnertype'
    };
    // AA partners
    public static AAPartners={
        finvu:'finvu',
        pirimid:'pirimid'
    };
    // Routes
    public static Routes = {
        Home: '',
        Login: 'login',
        Logout: 'logout',
        ResumeApplication: 'resumeApplication',
        Tellus: 'tellus',
        OfferSalaried: 'offersalaried',
        ExistingCustomer: 'existingCustomer',
        PricingConsent: 'pricingConsent',
        VerifyOfficialEmail: 'verifyOfficialEmail',
        ChatBoat: 'chatboat',
        ErrorPage: 'connectionError',
        Bitly: 'bitlyEmandateStatus',
        Esign: 'esign',
        EsignOtp: 'esignOtp',
        EsignThankYou: 'esignThankyou',
        //ADDED FOR BFLOCR
        BflOcrIncomeVerification:'bflOcrIncomeVerification',
        AccountSelection: 'account-selection',
        BankUpload:'bank-upload',
        Epbitly:'link-your-bankaccount',
        userDetails:'get-your-bank-consent',
        inprogessPage:'inprogress',
        StandAloneBankSelection: 'standalonebankselection'
    };
    // input type
    public static InputTypes = {
        ReadOnly: 'ReadOnly',
        Selection: 'Selection',
        Dynamic: 'Dynamic',
        Button: 'Button',
        Date: 'Date',
        Boolean: 'Boolean',
        InputBox: 'InputBox',
        CheckBox: 'boolean'
    };
    // SharedServiceDataKeys
    public static SharedServiceDataKeys = {
        JourneySource: 'JourneySource',
        OfferDetails: 'OfferDetails',
        Applications: 'applications',
        DateOfBirth: 'dateOfbirth',
        YMDob: 'YMDob',
        MobileNumber: 'mobileNumber',
        OfferlaunchData: 'offerlaunchData',
        isDirectproductLaunch: 'isDirectproductLaunch',
        productCategoryCode: 'productCategoryCode',
        isEdit: 'isEdit',
        oldLoanProduct: 'oldLoanProduct',
        EsignDocmentList: 'esignDocmentList',
        productid: 'productid',
        sourceChannel:'sourceChannel'
        
    };
    public static DateRanges = {
        MinAge: 21,
        MaxAge: 58
    };
    public static DataLayerPageTitleList = {
        ExistingCustomer: 'ExistingCustomer',
        Rejection: 'Reject',
        ResumeApplication: 'ResumeApplication',
        LoginPage: 'LoginPage',
        FooterPopUp: 'FooterPopUp',
        Logout: 'Logout',
        OfferSalaried: 'OfferSalaried',
        TellUsAbout: 'TellUsAbout',
        EsignDocumentList: 'EsignDocumentList',
    };
    public static productCategoryCode = {
        UL: 'UL',
        ULSME: 'ULSME',
        ULBOL: 'ULBOL',
        DHL: 'DHL',
        DHB: 'DHB',
        DLAP: 'DLAP',
        DLAPB: 'DLAPB',
        SOL: 'SOL',
        SPPL: 'SPPL'
    };
    public static APIURL = {
        ABTESTLAYOUT: 'l1',
        getGeoLocationBasedOnPin: '{DOMAIN01}/v1/referencedata/locatepin/{0}',
        applicationLaunch: '{DOMAIN01}/v1/applications/launch',
        applicationLaunchCr: '{DOMAIN01}/v1/creditcard/sfdc/leadcapture',
        validateOTP: '{DOMAIN01}/v1/applications/launch/validate',
        validateEsignOTP: '{DOMAIN01}/v1/esigndetails/{0}/validate',
        productLaunch: '{DOMAIN01}/v1/applications/{0}/product',
        startApplicationActiviti: '{DOMAIN01}/v1/insurances/cyber/workflow/process',
        completeActivitiTask: '{DOMAIN01}/v1/insurances/cyber/workflow/process',
        getActivitiTaskDetails: '{DOMAIN01}/v1/insurances/cyber/workflow/details',
        resumeGetOtp: '{DOMAIN01}/v1/logins/forms/mobile/otp',
        getSecretKey: '{DOMAIN01}/v1/logins/ui/keys/{0}',
        getTokenForUser: '{DOMAIN01}/v1/logins/ui',
        securedCookie: '{DOMAIN01}/v3/logins/ui',
        getAreaList: '{DOMAIN01}/v1/smartsearch/area?areaName=',
        getPaymentDetails: '{DOMAIN01}/v1/insurances/cyber/{applicationId}/booking/initiation',
        productLaunchSPPL:
            '{DOMAIN02}/pocketpl/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=SPPL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchOldSol:
            '{DOMAIN02}/ul/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=SOL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchNewSol:
            '{DOMAIN02}/ploffer/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=SOL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchDDOLProfLoan: '{DOMAIN02}/profloan/#/?{14}={15}&profession=Doctor&occupation=Salaried&prodCode=DDOL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchDCALProfLoan: '{DOMAIN02}/profloan/#/?{14}={15}&profession=CA&occupation=selfEmployed&prodCode=DCAL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchDBOL: '{DOMAIN02}/bl/#/?{14}={15}&professionType=Others&occupationType=selfEmployed&prodCode=DBOL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchHL: '{DOMAIN02}/sl/hl/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=DHL&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchHLBT: '{DOMAIN02}/sl/hlbt/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=DHB&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchLAP: '{DOMAIN02}/sl/lap/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=DLAP&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        productLaunchLAPBT: '{DOMAIN02}/sl/lapbt/#/?{14}={15}&professionType=Others&occupationType=Salaried&prodCode=DLAPB&offerId={0}&mob={1}&dob={2}&applicantKey={3}&applicationKey={4}&loanApplicationKey={5}&applicationApplicantKey={6}&isEdit={7}&utm_RefCode={8}&utm_source={9}&utm_medium={10}&utm_campaign={11}&utm_term={12}&utm_content={13}&uci={16}',
        resumeApplicationSPPL:
            '{DOMAIN02}/pocketpl/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationOldSOL:
            '{DOMAIN02}/ul/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationNewSOL:
            '{DOMAIN02}/ploffer/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationProfLoan:
            '{DOMAIN02}/profloan/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationDBOL:
            '{DOMAIN02}/bl/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationHL:
            '{DOMAIN02}/sl/hl/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationHLBT:
            '{DOMAIN02}/sl/hlbt/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationLAP:
            '{DOMAIN02}/sl/lap/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        resumeApplicationLAPBT:
            '{DOMAIN02}/sl/lapbt/#/customerLogin/existing?m={0}&d={1}&product={2}&applicationKey={3}&utm_source={4}&processId={5}&isEdit={6}',
        baseUrl: '{DOMAIN02}/commonoffer/#/',
        consentValidation: '{DOMAIN01}/v1/credit/applications/{0}/pricingconsent/null',
        consentPricingValidation: '{DOMAIN01}/v1/credit/applications/{0}/pricingconsent',
        pricingApprovalValidation: '{DOMAIN01}/v1/employeeportal/application/{0}/pricingapprovalthroughmail?action={1}',
        generateOtp: '{DOMAIN01}/v1/otp/generate',
        addUserConsent: '{DOMAIN03}/v1/whatsapp/addconsent',
        bitlyService : '{DOMAIN01}/v1/emandate/digio/details?emandateRes={0}',
        validateEsign : '{DOMAIN01}/v1/esigndetails/consent/validate',
        getAuthCodeForPricingApproval: '{DOMAIN01}/v1/auth/authcode?userType={0}&authType={0}',
        validateAuthCode: '{DOMAIN01}/v1/auth/invalidateAuthcode',
        generateServiceToken: '{DOMAIN01}/v1/auth/service-token',
        getOfficialMailId: "{DOMAIN01}/v1/credit/employeeportal/{0}/email?typeKey=67",
        validateEmail: "{DOMAIN01}/v1/credit/employeeportal/{0}/email?token={1}",

        ocrUrl:"{DOMAIN03}/v2/verification/income/",
        consentAccount:"{DOMAIN04}v1/webBFF/consent-account",
        initiateAA:"{DOMAIN04}v1/webBFF/initiateAA",
        transaction:"{DOMAIN04}v1/webBFF/account-aggregator/transaction",
        sessionUIToken:'{DOMAIN04}v1/login/sessions/',
        pcTokenUrl:'{DOMAIN04}v2/login/forms/mobile'
        // ocrUrl:"http://omverificationverificationdomainservice.dev.bfsgodirect.com/v2/verification/income/",
        //  ocrUrl:"http://10.61.112.147:8080/v2/verification/income/"
    };
    public static PageTitles = {
        Login: 'Login'
    };
    public static CurrencyCoversionUnits = {
        Lacs: 100000,
        Crore: 10000000
    };
    public static footerText = [
        {
            title: 'Lorem ipsum dolor sit amet',
            desc: 'consectetur adipiscing elit. Praesent consequat ligula in tortor ornare faucibus.'
        },
        {
            title: 'Lorem ipsum dolor sit amet',
            desc: 'consectetur adipiscing elit. Praesent consequat ligula in tortor ornare faucibus.'
        }
    ];
    public static EmitterEventTypes = {
        LoadingEvent: 'LoadingEvent',
        GlobalErrorEvent: 'GlobalErrorEvent',
        ProgressStateEvent: 'ProgressStateEvent',
        LoadingSmallLoaderEvent: 'SmallLoader',
        NavigationEvent: 'NavigationFlag',
        ProcessCallCompleteEvent: 'ProcessCallComplete',
        MobileAppCheck: 'MobileAppCheck',
        ServiceEvent: 'ServiceFail',
        HeaderTextChange:'HeaderTextChange'
    };
    public static ActivitiNextTaskKeys = {
    };
    /*Start: Secured Code mapping */
    public static CodeMapper = {
        'DHL': {
            code: 'DHL',
            key: 'hl',
            L2Code: 'SL',
            desc: 'Home Loan'
        },
        'DHB': {
            code: 'DHB',
            key: 'hlbt',
            L2Code: 'SL',
            desc: 'Home Loan Balance Transfer'
        },
        'DLAP': {
            code: 'DLAP',
            key: 'lap',
            L2Code: 'SL',
            desc: 'Loan Against Property'
        },
        'DLAPB': {
            code: 'DLAPB',
            key: 'lapbt',
            L2Code: 'SL',
            desc: 'Loan Against Property Balance Transfer'
        },
        'SOL': {
            code: 'SOL'
        },
        'DDOL': {
            code: 'DDOL'
        },
        'DCAL': {
            code: 'DCAL'
        },
        'DENG': {
            code: 'DENG'
        },
        'dbol': {
            code: 'dbol'
        },
        'DBOL': {
            code: 'DBOL'
        },
        'SPPL': {
            code: 'SPPL'
        }
    };
    /*End: Secured Code mapping */
    // AEM URL's
  public static AEMURLs = {
    // CompanyLogoImageUrl: '/content/dam/bajajfinserv/spa-banners/journey-peronal-loan/journey/BMarketsLogo.png',
    CompanyLogoImageUrl: '/content/dam/bajajfinserv/spa-banners/journey-peronal-loan/journey/ESign_Doc_Logo.png',
    CompanyLogoImageUrlFinvu: '/content/dam/bajajfinserv/spa-banners/journey-peronal-loan/journey/BMarketsLogoReverse.png',
  };
    public static ProductInfo = {
        UnsecuredLoan: {
          productKey: 10002,
          productCode: 'OMPL',
        },
      };
    
    public static partnerBaseUrl = {
        // finvu : '/finvu-aa-consent/',
        finvu:'/account-aggregator/'
      };
    public static setAaStorageKey={
        consentHandleId:'finvuconsentid',
        customerId:'finvucustomerid',
        mobileNumber:'mob',
        occupationIdentifier:'occupationIdentifier',
        source:'source'
      }
      public static utmKeys={
        utm_source: 'Utm_source',
        utm_medium: 'Utm_medium',
        utm_campaign: 'Utm_campaign',
        utm_term: 'Utm_term',
        utm_content: 'Utm_content',
      }
      public static setAaStorageKeySingleLink={
        redirectionUrl:'redirectionUrl',
        consentHandleId:'finvuconsentid',
        customerId:'finvucustomerid',
        mobileNumber:'mob',
        occupationIdentifier:'occupationIdentifier',
        source:'source',
        productid: 'productid',
        sourceChannel:'sourceChannel'
      }
      public static finvuStorageKeys = {
        fipDetails:'fipDetails',
        ConsentApproved:'ConsentApproved'
      }
      public static  CookieKeysAA ={
        userName:'userName',
        firstName:'firstName',
        lastName:'lastName',
        userPin:'userPin',
        userPan:'userPan',
        userEmail:'userEmail',
        userOccupationValue:'userOccupationValue',
        userOccupationType:'userOccupationType',
        userMob:'userMob',
        userDob:'userDob',
        authtoken:'authtoken',
        applicantId:'applicantId',
        headerResAuth:'Authtoken',
        applicationId:'applicationId',
        lastUpdatedDate:'lastUpdatedDate',
        profession:'FHCR'
    }
    public static aastatus = {
        initiated: 'INITIATED' ,
        created: 'CREATED' ,
        inProcess: 'IN-PROCESS',
        failed : 'FAILED',
        completed: 'COMPLETED'
}
    public static primidStatus = {
    inProcess: 'PROCESSING', 
    }
}
